import React from 'react';

import { CSSTransition } from 'react-transition-group';

import { IGame } from '../../../../../store/player/games/store';

import { Button } from '../../../../../components/Button/Button';
import Scorer from '../../Components/Scorer';

interface IWithdrawPlayerProps {
  withdrawMode: boolean;
  game: IGame;
  selectPlayerToWithdraw: (gameId: number, groupId: number) => () => void;
  onWithdrawToggle: () => void;
}

export const WithdrawPlayer: React.FunctionComponent<IWithdrawPlayerProps> = props => {
  const { withdrawMode, game, selectPlayerToWithdraw, onWithdrawToggle } = props;

  return (
    <CSSTransition in={withdrawMode} timeout={500} classNames="fade" unmountOnExit={true}>
      <div>
        <h2>WITHDRAW PLAYER</h2>
        <div className="scorers">
          {game &&
            game.group.enrollments.map(e => (
              <Scorer item={e} key={`scorer-${e.id}`}>
                <Button
                  variant={'outlined'}
                  color="primary"
                  className="select-scorer-button"
                  onClick={selectPlayerToWithdraw(game.id, e.id)}
                >
                  WITHDRAW
                </Button>
              </Scorer>
            ))}
        </div>
        <Button color="primary" className="save-scorer-button" onClick={onWithdrawToggle}>
          GO BACK
        </Button>
      </div>
    </CSSTransition>
  );
};
